module.exports = __webpack_public_path__ + "img/thickness.c4c34c48.webp";